import { Component } from 'react';
import CustomizedTextField from '../../Input/CustomizedTextField';
import { getCurrentFunctionName } from '../../../performanceModeManager';
import { Dialog, DialogContent } from '@mui/material';
import TextFieldWithSuggestions from '../../Input/TextFieldWithSuggestions';
import { withStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import ValidateIcon from '@mui/icons-material/Check';
import { clone } from '../../../utils';

const styles = {
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
};

class FormTextWithSuggestionsField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.multiline ? this.props.question.comment : this.props.subField ? this.props.question.value : this.props.question.single_text,
            modalOpenned: false,
            suggestions: this.generateSuggestions()
        }
    }

    static getDerivedStateFromProps(props, state) {

        if (state.typedJustNow)
            return state;

        state.value = props.multiline ? props.question.comment : props.subField ? props.question.value : props.question.single_text;
        return state;
    }

    generateSuggestions() {
        return this.props.metaQuestion.dynamic_list_values.map((suggestion) => {
            return {
                name: suggestion.name,
                value: suggestion
            }
        })
    }

    openModal() {
        if (!this.props.inputProperties.disabled && !this.state.modalOpenned)
            this.setState({
                modalOpenned: true,
            })
    }

    closeModal() {
        this.setState({ modalOpenned: false })
    }

    handleChange(value) {
        let response = clone(this.props.question);

        if (this.props.multiline)
            response.comment = value;
        else if (this.props.subField)
            response.value = value;
        else
            response.single_text = value;

        this.props.responseValueChange(response);
    }

    render() {
        const { classes } = this.props;
        console.perfLog(getCurrentFunctionName());

        return (
            <div>
                <Dialog open={this.state.modalOpenned} onClose={this.closeModal.bind(this)} fullScreen aria-labelledby="form-dialog-title">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {this.props.metaQuestion.question}
                            </Typography>
                            <IconButton color="inherit" onClick={this.closeModal.bind(this)} aria-label="Validate">
                                <ValidateIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Toolbar/>
                    <DialogContent className="without-side-padding">
                        <TextFieldWithSuggestions onValueChange={this.handleChange.bind(this)} strict={true}
                            value={this.state.value} multiline={this.props.multiline} suggestions={this.state.suggestions}
                            multiSelect={this.props.metaQuestion.dynamic_list_multi_select} 
                            hasgrouping={this.props.metaQuestion.dynamic_list_has_grouping}/>
                    </DialogContent>
                </Dialog>
                <CustomizedTextField onMouseDown={this.openModal.bind(this)}
                    onBlur={() => {
                        if (typeof this.props.save === "function") {
                            this.props.save();
                        }                        
                    }}
                    {...this.props.inputProperties} value={this.state.value}
                    className={this.props.inputProperties.className + " full_size control-margin-top"}
                    multiline={this.props.multiline} inputProps={{ onClick: this.openModal.bind(this), maxLength: 800 }} />
                <div style={{
                    marginLeft: "5px",
                    fontSize: "0.75rem",
                    color: "#000000ff",
                }}>
                    {this.state.value?.length + "/800" || 0}
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(FormTextWithSuggestionsField);
